import React, { useEffect } from "react";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import Modal from "./Modal";
import Button from "./Button";
import SortContext from "context/SortContext";
import { useQueryClient } from "@tanstack/react-query";
import { useGlobalContext } from "context/GlobalContext";

const SortModal = ({ open, handleClose, title, list, isBtn }) => {
  const queryClient = useQueryClient();
  const { setSelectedSortValue, selectedSortValue } = React.useContext(SortContext);
  const { sortIcon, sortValue, setSortValue } = useGlobalContext();

  const onChange = (event) => {
    queryClient.removeQueries("collectiondesigns");

    const value = event.target.value;
    setSelectedSortValue((prev) => (prev === value ? "" : value));
    setSortValue((prev) => (prev === value ? "" : value));
    handleClose();
  };

  useEffect(() => {
    let appliedSortValue = sessionStorage.getItem("appliedSortValue") || 0;
    if (appliedSortValue > 0) {
      setSelectedSortValue((prev) => (prev === appliedSortValue ? "" : appliedSortValue));
    }
  }, []);

  return (
    // <Modal open={open} handleClose={handleClose} style={{ width: "auto" }}>
    //   <Typography id="modal-drawer-title" variant="h5" style={{ fontFamily: "karla", fontWeight: "500" }}>
    //     {title}
    //   </Typography>
    //   <Box mt={"20px"} p={0}>
    //     <FormControl>
    //       <RadioGroup value={sortIcon ? sortValue : selectedSortValue}>
    //         {list
    //           .filter((item) => item.access === undefined || item.access)
    //           ?.map((item) => (
    //             <FormControlLabel
    //               key={item.id}
    //               value={item.id}
    //               control={<Radio disableRipple onClick={onChange} disableFocusRipple sx={{ color: "black", "&.Mui-checked": { color: "black" }, paddingLeft: "0px" }} />}
    //               label={item.name}
    //               sx={{ color: "black", margin: 0, paddingBottom: 0.5, paddingTop: 0.6, gap: "1rem" }}
    //             />
    //           ))}
    //       </RadioGroup>
    //     </FormControl>
    //     {isBtn && (
    //       <Box display="flex" justifyContent="center" width="100%" mt={1}>
    //         <Button
    //           variant="contained"
    //           // disabled={!selectedValue}
    //           sx={{
    //             backgroundColor: selectedSortValue ? "#50C878" : "#444444",
    //             "&:hover": {
    //               backgroundColor: selectedSortValue ? "#50C878" : "#444444",
    //             },
    //             width: "100%",
    //             height: "50px",
    //             borderRadius: "5px",
    //           }}
    //         >
    //           View Collection
    //         </Button>
    //       </Box>
    //     )}
    //   </Box>
    // </Modal>
    <Modal open={open} handleClose={handleClose} style={{ width: "auto", maxHeight: "none" }}>
      <Box
        sx={{
          backgroundColor: "white",
          padding: "10px", // Reduced padding
          borderRadius: "8px",
          maxHeight: "80vh", // Limit modal height
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          id="modal-drawer-title"
          variant="h5"
          sx={{
            fontFamily: "Poppins",
            fontWeight: "500",
            position: "sticky",
            fontSize: "24px",
            top: 0,
            backgroundColor: "white",
            zIndex: 1,
            paddingBottom: "5px", // Reduced bottom padding
          }}
        >
          {title}
        </Typography>

        <Box
          mt={"10px"} // Reduced margin-top
          p={0}
          sx={{
            overflowY: "auto",
            flexGrow: 1,
            pr: 0.5, // Slight padding on the right to avoid clipping content
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
            },
          }}
        >
          <FormControl>
            <RadioGroup value={sortIcon ? sortValue : selectedSortValue}>
              {list
                .filter((item) => item.access === undefined || item.access)
                ?.map((item) => (
                  <FormControlLabel
                    key={item.id}
                    value={item.id}
                    control={
                      <Radio
                        disableRipple
                        onClick={onChange}
                        disableFocusRipple
                        sx={{
                          color: "black",
                          "&.Mui-checked": { color: "black" },
                          paddingLeft: "0px",
                        }}
                      />
                    }
                    label={item.name}
                    sx={{
                      color: "black",
                      margin: 0,
                      paddingBottom: 0.5,
                      paddingTop: 0.4, // Slightly reduced padding
                      gap: "0.5rem", // Reduced gap
                      "& .MuiTypography-root": {
                        fontFamily: "karla !important",
                        fontSize: "18px",
                        fontWeight: "400",
                      },
                    }}
                  />
                ))}
            </RadioGroup>
          </FormControl>
        </Box>

        {isBtn && (
          <Box display="flex" justifyContent="center" width="100%" mt={1}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: selectedSortValue ? "#50C878" : "#444444",
                "&:hover": {
                  backgroundColor: selectedSortValue ? "#50C878" : "#444444",
                },
                width: "100%",
                height: "45px", // Slightly reduced button height
                borderRadius: "5px",
              }}
            >
              View Collection
            </Button>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default SortModal;
